var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoachMetricsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EDEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 26C22.7167 26 22.4792 25.9042 22.2875 25.7125C22.0958 25.5208 22 25.2833 22 25V20C22 19.7167 22.0958 19.4792 22.2875 19.2875C22.4792 19.0958 22.7167 19 23 19H25C25.2833 19 25.5208 19.0958 25.7125 19.2875C25.9042 19.4792 26 19.7167 26 20V25C26 25.2833 25.9042 25.5208 25.7125 25.7125C25.5208 25.9042 25.2833 26 25 26H23ZM17 26C16.7167 26 16.4792 25.9042 16.2875 25.7125C16.0958 25.5208 16 25.2833 16 25V11C16 10.7167 16.0958 10.4792 16.2875 10.2875C16.4792 10.0958 16.7167 10 17 10H19C19.2833 10 19.5208 10.0958 19.7125 10.2875C19.9042 10.4792 20 10.7167 20 11V25C20 25.2833 19.9042 25.5208 19.7125 25.7125C19.5208 25.9042 19.2833 26 19 26H17ZM11 26C10.7167 26 10.4792 25.9042 10.2875 25.7125C10.0958 25.5208 10 25.2833 10 25V16C10 15.7167 10.0958 15.4792 10.2875 15.2875C10.4792 15.0958 10.7167 15 11 15H13C13.2833 15 13.5208 15.0958 13.7125 15.2875C13.9042 15.4792 14 15.7167 14 16V25C14 25.2833 13.9042 25.5208 13.7125 25.7125C13.5208 25.9042 13.2833 26 13 26H11Z",
    fill: "#585F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachMetricsIcon);
export default __webpack_public_path__ + "static/media/coach-metrics-icon.647ae5a9f4c92c93dbf2800e4f255ff1.svg";
export { ForwardRef as ReactComponent };